import classnames from "classnames";
import parse from "html-react-parser";
import PropTypes from "prop-types";
import { useFormContext, useWatch } from "react-hook-form";

import "./radioButton.scss";

const RadioButton = ({ name, options, fieldIndex, layout }) => {
  const { register, control } = useFormContext();
  const currentValue = useWatch({
    control,
    name,
  });

  const isLayoutHorizontal = layout === "horizontal";

  return (
    <div
      className={classnames("radio-button-group", {
        "radio-button-group__vertical": !isLayoutHorizontal,
        "radio-button-group__horizontal": isLayoutHorizontal,
      })}
      key={fieldIndex}
    >
      {options.options?.map(({ label, subtext, value }, index) => {
        const optionValue = value;
        return (
          <label
            key={index}
            className={classnames({
              "radio-button-group__option-vertical": !isLayoutHorizontal,
              "radio-button-group__option-horizontal": isLayoutHorizontal,
            })}
          >
            {isLayoutHorizontal ? (
              <>
                <input
                  name={`${name}-${fieldIndex}`}
                  type="radio"
                  value={optionValue}
                  checked={currentValue === optionValue}
                  {...register(name, { ...(options || {}) })}
                  disabled={options.readOnly}
                  defaultChecked={options?.checked}
                />
                <div className="radio-button-group__indicator" />
                <div className="radio-button-group__label">
                  <p>{parse(label)}</p>
                  {subtext && <p>{subtext}</p>}
                </div>
              </>
            ) : (
              <>
                <div className="radio-button-group__label">{label}</div>
                <input
                  name={`${name}-${fieldIndex}`}
                  type="radio"
                  value={optionValue}
                  checked={currentValue === optionValue}
                  {...register(name)}
                  disabled={options.readOnly}
                  defaultChecked={options?.checked}
                />
                <div className="radio-button-group__indicator" />
              </>
            )}
          </label>
        );
      })}
    </div>
  );
};

RadioButton.propTypes = {
  name: PropTypes.string,
  options: PropTypes.object,
  fieldIndex: PropTypes.string,
  layout: PropTypes.string,
};

export default RadioButton;
